module.exports = __webpack_public_path__ + "static/img/eureka_icon_11.86e41b08.png";